module.exports = __webpack_public_path__ + "static/media/b5d5592a-a01b-49e4-899f-a9877e230b7c.39cb1785.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/b5d5592a-a01b-49e4-899f-a9877e230b7c.jpg
// module id = 845
// module chunks = 0